import { useEffect, useSyncExternalStore } from "react";
import { flushOutbox, outboxSnapshot, startOutboxRetries, subscribeOutbox } from "../lib/outbox";
import type { OutboxEntry } from "../lib/outbox";

// useSyncExternalStore rather than an effect+setState pair: the outbox is
// an external store, and this keeps the roster in step with retries that
// happen on a timer or on `online`, without a render-loop lint exception.
export function useOutbox(sessionID: string): Map<string, OutboxEntry> {
  const all = useSyncExternalStore(subscribeOutbox, outboxSnapshot, outboxSnapshot);

  useEffect(() => {
    const stop = startOutboxRetries();
    void flushOutbox();
    return stop;
  }, []);

  const byTeacher = new Map<string, OutboxEntry>();
  for (const entry of all) {
    if (entry.sessionID === sessionID) byTeacher.set(entry.teacherID, entry);
  }
  return byTeacher;
}
